export default "__VITE_ASSET__BpR8kpjx__"